import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AllocationTabSetSelectionService } from '../../services/allocation-tab-set-selection.service';
import { DistributionTabSetSelectionService } from '../../services/distribution-tab-set-selection.service';

@Component({
  selector: 'app-tab-selection',
  templateUrl: './tab-selection.component.html',
  styleUrls: ['./tab-selection.component.scss'],
  standalone: false
})
export class TabSelectionComponent implements OnInit {
  private distributionTabSetSelectionService = inject(DistributionTabSetSelectionService);
  private allocationTabSetSelectionService = inject(AllocationTabSetSelectionService);
  private destroyRef = inject(DestroyRef);

  @Input() defaultSelection: string;
  @Input() tabNames: string[];
  @Input() distributionTabSelection: boolean;
  @Input() allocationTabSelection: boolean;
  @Input() showBorder: boolean;
  @Input() disabled: boolean;
  @Input() slimDesign: boolean;
  @Output() changeSelectionTab = new EventEmitter<string>();

  public selectedTab: string;

  ngOnInit(): void {
    this.selectedTab = this.defaultSelection ? this.defaultSelection : this.tabNames?.[0];
    this.initSelectionChangeListeners();
  }

  initSelectionChangeListeners(): void {
    if (this.distributionTabSelection) {
      this.distributionTabSetSelectionService.newValue.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.changeSelection(value);
      });
    }

    if (this.allocationTabSelection) {
      this.allocationTabSetSelectionService.newValue.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.changeSelection(value);
      });
    }
  }

  public changeSelection(tab: string): void {
    this.selectedTab = tab;
    this.changeSelectionTab.emit(this.selectedTab);
  }
}
